import { Fetcher } from "./Fetcher.js";
import { ConvertUtils } from "../convert/ConvertUtils.js";
class HttpResponseError extends Error {
}
const isHttpResponseError = (data) => {
  return data instanceof HttpResponseError;
};
class HttpFetcher extends Fetcher {
  // get/post/put/patch/head/delete가 전부 config.config.fetch.method를 세팅하려고 caller가
  // 넘긴 config(.fetch) 객체를 직접 mutate했다 - 같은 config 객체를 여러 호출이 공유하면
  // (예: Promise.all로 동시에 get/post) 서로의 method를 덮어쓰는 레이스가 생겼다. caller의
  // 객체는 절대 건드리지 않고, 얕은 복사본 위에 method만 얹어서 반환한다.
  withMethod(config, method) {
    return { ...config, config: { ...config.config, fetch: { ...config.config?.fetch, method } } };
  }
  get(config) {
    return this.fetch(this.withMethod(config, "GET"));
  }
  post(config) {
    return this.fetch(this.withMethod(config, "POST"));
  }
  patch(config) {
    return this.fetch(this.withMethod(config, "PATCH"));
  }
  put(config) {
    return this.fetch(this.withMethod(config, "PUT"));
  }
  head(config) {
    return this.fetch(this.withMethod(config, "HEAD"));
  }
  delete(config) {
    return this.fetch(this.withMethod(config, "DELETE"));
  }
  async beforeProxyFetch(config) {
    return config;
  }
  async afterProxyFetch(config) {
    return config.response;
  }
  afterSuccess(config, pipe) {
  }
  afterSuccessTransform(config, pipe) {
  }
  before(config, pipe) {
  }
  error(config, pipe, e) {
  }
  finally(config, pipe) {
  }
  beforeFetch(fetch2) {
  }
  afterFetch(fetch2, response) {
  }
  // protected async errorTransform(e: any): Promise<HttpResponseError<any>> {
  async errorTransform(e) {
    const httpResponseError = new HttpResponseError();
    httpResponseError.error = e;
    if (e instanceof Response) {
      httpResponseError.response = e;
      try {
        httpResponseError.body = await e.clone().text();
        httpResponseError.message = e.statusText;
      } catch (e2) {
        httpResponseError.body = e2;
        httpResponseError.message = e2.message;
      }
    } else {
      httpResponseError.body = e;
      httpResponseError.message = e?.message;
    }
    return httpResponseError;
  }
  async execute(fetcherRequest) {
    let target = fetcherRequest.target;
    let config = fetcherRequest.config;
    if (!(target instanceof URL) && typeof target !== "string") {
      const searchParams = ConvertUtils.toURLSearchParams(target.searchParams ?? {});
      try {
        const url = new URL(target.url);
        searchParams.forEach((value, key) => {
          url.searchParams.append(key, value);
        });
        target = url;
      } catch (e) {
        if (typeof target.url === "string") {
          const searchParamString = searchParams.toString();
          target = target.url + (searchParamString ? "?" + searchParamString : "");
        } else {
          target = "";
        }
      }
    }
    const beforeProxyData = { requestInfo: target, init: config?.fetch };
    let beforeData = config?.beforeProxyFetch ? await config?.beforeProxyFetch(beforeProxyData) : beforeProxyData;
    beforeData = config?.skipGlobalBeforeProxyFetch ? beforeData : await this.beforeProxyFetch(beforeData);
    target = beforeData.requestInfo;
    if (beforeData.init) {
      config ?? (config = {});
      config.fetch = beforeData.init;
    }
    let requestInit = config?.fetch;
    if (config?.fetch && "timeout" in config.fetch) {
      const timeoutSignal = AbortSignal.timeout(config.fetch.timeout);
      const signal = config.fetch.signal ? AbortSignal.any([timeoutSignal, config.fetch.signal]) : timeoutSignal;
      requestInit = { ...config.fetch, signal };
    }
    this.beforeFetch({ target, requestInit });
    return (config.fetcher ?? fetch)(target, requestInit).then(async (it) => {
      this.afterFetch({ target, requestInit }, it);
      const afterProxyData = {
        fetch: { target, requestInit },
        config: beforeData,
        response: it
      };
      afterProxyData.response = config?.afterProxyFetch ? await config.afterProxyFetch(afterProxyData) : it;
      afterProxyData.response = config?.skipGlobalAfterProxyFetch ? afterProxyData.response : await this.afterProxyFetch(afterProxyData);
      it = afterProxyData.response;
      config?.fetchResponseAfterCallBack?.(it, config);
      if (!config?.allowedResponseNotOk && !it.ok) {
        throw it;
      }
      const data = config?.hasResponseErrorChecker?.(it, config);
      if (data) {
        throw data;
      }
      return it;
    });
  }
}
export {
  HttpFetcher,
  HttpResponseError,
  isHttpResponseError
};
//# sourceMappingURL=HttpFetcher.js.map
